import { useEffect, useState } from 'react';
import { useAppContext } from '@/Main';
import { changeBgColor } from '@/utils/pre-load/changeBgColor';

interface TrackerVideoPreloadProps {
  src: string;
  autoPlay?: boolean;
  loop?: boolean;
  muted?: boolean;
  maxWidth?: number;
  className?: string;
}

const TrackerVideoPreload = ({
  src,
  autoPlay = false,
  loop = false,
  muted = false,
  maxWidth = 900,
  className = ''
}: TrackerVideoPreloadProps) => {
  const { config } = useAppContext() as unknown as {
    config: { isDark: boolean };
  };
  const [isVideoReady, setIsVideoReady] = useState(false);

  useEffect(() => {
    setIsVideoReady(false);
  }, [src]);

  return (
    <div className={`mt-3 text-center${className ? ` ${className}` : ''}`}>
      <div style={{ maxWidth, width: '100%', margin: '0 auto' }}>
        {!isVideoReady && (
          <div
            className="rounded-3"
            style={{
              width: '100%',
              aspectRatio: '16/9',
              background: changeBgColor(config.isDark ? 'dark' : 'light'),
              backgroundSize: '200% 100%',
              backgroundPosition: '100% 0',
              animation: 'run 2s infinite'
            }}
          />
        )}
        <video
          key={src}
          src={src}
          controls
          preload="auto"
          playsInline
          autoPlay={autoPlay}
          loop={loop}
          muted={muted || autoPlay}
          className={`rounded-3 w-100${isVideoReady ? '' : ' d-none'}`}
          style={{ maxWidth, height: 'auto' }}
          onLoadedData={() => setIsVideoReady(true)}
          onError={() => setIsVideoReady(true)}
        />
      </div>
    </div>
  );
};

export default TrackerVideoPreload;
